import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { DateAdapter } from '@angular/material/core';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from 'src/app/modules/local-storage/local-storage.module';
import { saveAs } from 'file-saver';
import * as htmlToPdfmake from 'html-to-pdfmake';
import * as moment from 'moment';
import * as pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { environment } from '../../../../../environments/environment';
import { UserService } from '../../../auth-client/services/user.service';
import { NotifyService } from '../../../brover-notify/services/notify.service';
import { ArticleService } from '../../services/article.service';
import { FilterService } from '../../services/filter.service';
import { OrderService } from '../../services/order.service';
import { ShoppingService } from '../../services/shopping.service';
import { TenderService } from '../../services/tender.service';
import { SaveOrderDialogComponent } from '../place-order/save-order-dialog/save-order-dialog.component';
import { DeliveryAdresDialogComponent } from './delivery-adres-dialog/delivery-adres-dialog.component';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
    selector: "brover-order-statistics",
    templateUrl: "./order-statistics.component.html",
    styleUrls: ["order-statistics.component.sass"],
    standalone: false
})
export class OrderStatisticsComponent implements OnInit, OnDestroy {
  constructor(
    public userService: UserService,
    private router: Router,
    private notify: NotifyService,
    private activated: ActivatedRoute,
    private dateAdapter: DateAdapter<Date>,
    public shoppingService: ShoppingService,
    private articleService: ArticleService,
    public dialog: MatDialog,
    public filterService: FilterService,
    public orderService: OrderService,
    public tenderService: TenderService,
    public localstorageService: LocalStorageService
  ) { }
  public company: any;

  public factuurAdress = {
    address: "Plijn 1622",
    postal_code: "3242 KS",
    place: "Eindhoven",
  };

  public deliveryAddres = {
    address: "Plijn 1622",
    postal_code: "3242 KS",
    place: "Eindhoven",
  };

  public isfromquickOrrder = false;
  public isFromTenders = false;
  public tenderId: number = null;

  articles;
  order: {
    id?: number;
    deliverDate: Date;
    shoppingBag: any[];
    references?: string;
    car_type: any;
    brand: any;
    address: string;
    place: string;
    postal_code: string;
    tender?: any;
    personalReference?: string;
  };
  isOrderd = true;
  startDate = new Date();

  permittedDays = [];
  barredDays = [];
  // tslint:disable-next-line: max-line-length
  specialDays = [
    new Date("December 8 2024"),
    new Date("December 9 2024"),
    new Date("December 10 2024"),
    new Date("December 11 2024"),
    new Date("December 12 2024"),
    new Date("December 13 2024"),
    new Date("December 14 2024"),
    new Date("December 15 2024"),
    new Date("December 16 2024"),
    new Date("December 17 2024"),
    new Date("December 18 2024"),
    new Date("December 19 2024"),
    new Date("December 20 2024"),
    new Date("December 21 2024"),
    new Date("December 22 2024"),
    new Date("December 23 2024"),
    new Date("December 24 2024"),
    new Date("December 25 2024"), 
    new Date("December 26 2024"),
    new Date("December 27 2024"),
    new Date("December 28 2024"),
    new Date("December 29 2024"),
    new Date("December 30 2024"),
    new Date("December 31 2024"), 
    new Date("January 1 2025"), 
    new Date("January 2 2025"),
    new Date("January 3 2025"),
    new Date("January 4 2025"),
    new Date("January 5 2025"),
    new Date("January 6 2025"),  
    new Date("January 7 2025"),
    new Date("January 8 2025"),
    new Date("January 9 2025"),
    new Date("January 10 2025"),
  ];
  myFilter;
  ngOnInit() {
    this.dateAdapter.setLocale("nl");
    this.dateAdapter.getFirstDayOfWeek = () => 1;
    // new call van jef
    this.userService.getCompanyInfo().subscribe((x) => {
      if (x["success"]) {
        const data = x["data"];

        this.company = data.company;

        this.factuurAdress.postal_code = this.company.PostcodePostadres;
        this.factuurAdress.place = this.company.WoonplaatsPostadres;
        this.factuurAdress.address = this.company.Postadres;
        this.deliveryAddres.postal_code = this.company.Postcode;
        this.deliveryAddres.place = this.company.Woonplaats;
        this.deliveryAddres.address = this.company.Straat;

        const currentDate = new Date();
        const days: [] = data.days;
        days.forEach((day) => {
          switch (day) {
            case "MA":
              this.permittedDays.push(1);
              break;
            case "DI":
              this.permittedDays.push(2);
              break;
            case "WO":
              this.permittedDays.push(3);
              break;
            case "DO":
              this.permittedDays.push(4);
              break;
            case "VR":
              this.permittedDays.push(5);
              break;
            case "ZA":
              this.permittedDays.push(6);
              break;
            case "ZO":
              this.permittedDays.push(0);
              break;
          }
        });
        this.permittedDays.forEach((permittedDay) => {
          let amountOfDaysUntilNextPermittedDay = 0;
          for (let weekDay = currentDate.getDay(); weekDay <= 6; weekDay++) {
            if (weekDay >= 1 && weekDay <= 5) {
              if (permittedDay === weekDay) {
                const [hour, minutes] = data.company.Waarde.split(":");
                const lastOrderDate = new Date();
                lastOrderDate.setHours(hour);
                lastOrderDate.setMinutes(minutes);
                if (
                  amountOfDaysUntilNextPermittedDay < 2 ||
                  (amountOfDaysUntilNextPermittedDay === 2 &&
                    moment(lastOrderDate).diff(moment(this.startDate)) < 0)
                ) {
                  let blockedDay = moment(currentDate)
                    .add(amountOfDaysUntilNextPermittedDay, "days")
                    .toDate();
                  if (blockedDay.getDay() > 5 || blockedDay.getDay() < 1) {
                    blockedDay = moment(blockedDay).add(2, "days").toDate();
                  }
                  this.barredDays.push(blockedDay);
                }
                break;
              }
              amountOfDaysUntilNextPermittedDay += 1;
            }
            if (weekDay === 6) {
              weekDay = 0;
            }
          }
        });
        this.myFilter = (date: Date): boolean => {
          // Check if day is permitted
          if (
            this.permittedDays.findIndex(
              (permittedDays) => permittedDays === date.getDay()
            ) !== -1
          ) {
            // Check if permitted day is blocked or barred
            if (
              this.barredDays.findIndex(
                (barredDays: Date) =>
                  barredDays.getDate() === date.getDate() &&
                  barredDays.getMonth() === date.getMonth() &&
                  barredDays.getFullYear() === date.getFullYear()
              ) !== -1
            ) {
              return false;
            } else {
              // Check if day is a special Day
              return (
                this.specialDays.findIndex(
                  (specialDays: Date) =>
                    specialDays.getDate() === date.getDate() &&
                    specialDays.getMonth() === date.getMonth() &&
                    specialDays.getFullYear() === date.getFullYear()
                ) === -1
              );
            }
          }
          return false;
        };
      }
    });

    this.activated.queryParams.subscribe((x) => {
      if (x.from === "bulk-order") {
        this.isfromquickOrrder = true;
      } else if (x.from === "tenders") {
        this.isFromTenders = true;
        this.tenderId = x.tenderId;
      }
    });
    this.activated.paramMap.subscribe((params) => {
      if (params.get("value") === "true") {
        this.isOrderd = false;
        this.order = this.shoppingService.order;

        if (this.order.brand != null) {
          this.filterService.brand = this.order.brand;
        } else {
          this.filterService.clearBrand();
        }

        if (this.order.car_type != null) {
          this.filterService.type = this.order.car_type;
        } else {
          this.filterService.clearType();
        }

        this.articleService
          .getArticlesFromCsv(
            // tslint:disable-next-line:max-line-length
            {
              articleNumbers: this.order.shoppingBag.map(
                (x) => x.articleNumber
              ),
              companyId: this.userService.getCompany().id,
              newPrice: this.order.car_type.newPrice,
            }
          )
          .subscribe((x) => {
            this.articles = x.articles;
          });
      } else if (params.get("value") === "false") {
        this.isOrderd = false;
        this.order = this.shoppingService.order;

        this.articleService
          .getArticlesFromCsv(
            // tslint:disable-next-line:max-line-length
            {
              articleNumbers: this.order.shoppingBag.map(
                (x) => x.articleNumber
              ),
              companyId: this.userService.getCompany().id,
              newPrice: this.order.car_type.newPrice,
            }
          )
          .subscribe((x) => {
            this.articles = x.articles;
          });
      } else {
        this.isOrderd = true;
        this.order = this.shoppingService.order;
        this.orderService
          .getOrder(params.get("id") as unknown as number)
          .subscribe((x) => {
            this.order.address = x["data"]["address"];
            this.order.personalReference = x["data"]["personalReference"];
            this.order.place = x["data"]["place"];
            this.order.postal_code = x["data"]["postal_code"];
            this.order.tender = x["data"]["tender"];
          });

        this.articleService
          .getArticlesFromCsv(
            // tslint:disable-next-line:max-line-length
            {
              articleNumbers: this.order.shoppingBag.map(
                (x) => x.articleNumber
              ),
              companyId: this.userService.getCompany().id,
              newPrice: this.order.car_type.newPrice,
            }
          )
          .subscribe((x) => {
            this.articles = x.articles;
          });
      }
    });
  }

  dateCheck(from, to, check) {
    let fDate, lDate, cDate;
    fDate = Date.parse(from);
    lDate = Date.parse(to);
    cDate = Date.parse(check);
    return cDate <= lDate && cDate >= fDate;
  }

  dateChange(event: MatDatepickerInputEvent<any & Date>) {
    this.order.deliverDate = event.value;
  }

  openAddressesDialog(): void {
    const selected =
      this.deliveryAddres.address +
      " - " +
      this.deliveryAddres.postal_code +
      " - " +
      this.deliveryAddres.place;
    const dialogRef = this.dialog.open(DeliveryAdresDialogComponent, {
      data: { company: this.company, selected },
    });
    dialogRef.afterClosed().subscribe((x?: string) => {
      if (!x) {
        return;
      }

      const [address, postalCode, city] = x.split(" - ");
      this.deliveryAddres.address = address;
      this.deliveryAddres.postal_code = postalCode;
      this.deliveryAddres.place = city;
    });
  }

  finishOrder() {
    if (this.order.deliverDate === null) {
      this.notify.error("Bestelling moet een afleverdatum hebben");
      return;
    }
    if (
      this.order.references === undefined ||
      this.order.references === null ||
      this.order.references.length === 0
    ) {
      this.notify.error("Bestelling moet een referentie hebben");
      return;
    }

    if (this.order.shoppingBag.length === 0) {
      this.notify.error("Bestelling moet artiekelen hebben");
      return;
    }


    const obj = {
      reference: this.order.references,
      personalReference: this.order.personalReference,
      address: this.order.address
        ? this.order.address
        : this.deliveryAddres.address,
      postal_code: this.order.address
        ? this.order.postal_code
        : this.deliveryAddres.postal_code,
      place: this.order.address ? this.order.place : this.deliveryAddres.place,
      delivery_date: new Date(this.order.deliverDate).toISOString(),
      articles: this.order.shoppingBag,
      companyId: this.userService.user.getValue().companies[0].company.id,
      brand: this.order.brand.id,
      car: this.order.car_type.id,
      tenderId: this.tenderId || undefined,
    };
    this.shoppingService.order = this.order;
    let index = 1;
    if (this.userService.user.getValue().id === 680) {

      var form = document.createElement("form");
      form.method = "POST";
      form.action = this.localstorageService.get('oci-callback-url');   //TO BE HOOKURL 

      console.log('articles');
      console.log(obj.articles);
      console.log(obj.articles.map(x => x.articleNumber))
      this.articleService
        .getArticlesFromCsv({
          articleNumbers: obj.articles.map(x => x.articleNumber),
          companyId: 229,
          newPrice: false,
        }).subscribe(x => {
          for (const iterator of x.articles) {
            var ociQuantity = document.createElement("input");
            ociQuantity.name = `NEW_ITEM-QUANTITY[${index}]`;
            ociQuantity.value = obj.articles.find(x => x.articleNumber === iterator.Nummer).qty as string || '1';
            form.appendChild(ociQuantity);
            var ociDescription = document.createElement("input");
            ociDescription.name = `NEW_ITEM-DESCRIPTION[${index}]`;
            ociDescription.value = iterator.KorteTekst;
            form.appendChild(ociDescription);

            var ociPrice = document.createElement("input");
            ociPrice.name = `NEW_ITEM-PRICE[${index}]`;
            ociPrice.value = iterator.brutoprijs;

            form.appendChild(ociPrice);


            var ociExtProductId = document.createElement("input");
            ociExtProductId.name = `NEW_ITEM-EXT_PRODUCT_ID[${index}]`;
            ociExtProductId.value = iterator.Nummer;


            form.appendChild(ociExtProductId);


            var ociVendor = document.createElement('input');
            ociVendor.name = `NEW_ITEM-VENDOR[${index}]`;
            ociVendor.value = "BROVERBWI";
            form.appendChild(ociVendor);

            var ociCurrency = document.createElement('input');
            ociCurrency.name = `NEW_ITEM-CURRENCY[${index}]`;
            ociCurrency.value = "EUR";
            form.appendChild(ociCurrency);

            var ociUnit = document.createElement('input');
            ociUnit.name = `NEW_ITEM-UNIT[${index}]`;
            ociUnit.value = 'PCE'
            form.appendChild(ociUnit);

            var ociMatgroup = document.createElement('input');
            ociMatgroup.name = `NEW_ITEM-MATGROUP[${index}]`;
            ociMatgroup.value = '4170';
            form.appendChild(ociMatgroup);
            index++;

          }

          var okCodeAddi = document.createElement('input');
          okCodeAddi.name = '~OkCode';
          okCodeAddi.value = 'ADDI'
          form.appendChild(okCodeAddi);

          var target = document.createElement('input');
          target.name = 'TARGET';
          target.value = '_top'
          form.appendChild(target);

          var target = document.createElement('input');
          target.name = 'ZCUSTFIELD8';
          target.value = this.order.references
          form.appendChild(target);

          var caller = document.createElement('input');
          caller.name = '~CALLER'
          caller.value = 'CTLG'
          form.appendChild(caller);


          document.body.appendChild(form);
          form.submit();

        });


      // this.articleService.orderArticles(obj).subscribe((x: any) => {


      //           this.notify.success("Bedankt voor het bestellen");

      // });

    } else {
      this.articleService.orderArticles(obj).subscribe((x: any) => {


        if (x.success) {
          this.notify.success("Bestelling geplaatst");

          this.router.navigate(["/dashboard/thanks"], {
            queryParams: {
              orderId: x["data"]["order"]["id"],
              tenderId: this.tenderId,
            },
          });
        }
      });
    }

  }

  addQuantity(articleNumber: string) {
    this.order.shoppingBag.find(
      (x) => x.articleNumber === articleNumber
    ).qty += 1;
    this.shoppingService.order = this.order;
  }

  removeQuantity(articleNumber: string) {
    this.order.shoppingBag.find(
      (x) => x.articleNumber === articleNumber
    ).qty -= 1;
    this.shoppingService.order = this.order;
  }

  removeFromShoppingCard(articleNumber: any) {
    this.order.shoppingBag.splice(
      this.order.shoppingBag.findIndex(
        (x) => x.articleNumber === articleNumber
      ),
      1
    );
    this.shoppingService.order = this.order;
    this.articles.splice(
      this.articles.findIndex((x) => x.Nummer === articleNumber),
      1
    );
  }

  editOrder() {
    this.shoppingService.shoppingCard = this.order.shoppingBag;

    const copy: {
      deliverDate: Date;
      shoppingBag: any[];
      references?: string;
      car_type: any;
      brand: any;
      address: string;
      place: string;
      postal_code: string;
    } = JSON.parse(JSON.stringify(this.order));
    copy.shoppingBag = [];
    this.shoppingService.order = copy;

    this.router.navigate(["/", "dashboard", "place-order", "configuration"]);
  }

  getTotalPrice() {
    let price = 0;
    this.order.shoppingBag.forEach((x) => {
      const art = this.articles.find((y) => y.Nummer === x.articleNumber);
      if (art) {
        price += x.qty * art.brutoprijs;
      }
    });
    return price.toFixed(2);
  }

  getTotalTime() {
    let time = 0;
    this.order.shoppingBag.forEach((x) => {
      const art = this.articles.find((y) => y.Nummer === x.articleNumber);
      if (art) {
        time += x.qty * parseInt(art.montageTijd, 10);
      }
    });
    return time > 60
      ? (time / 60).toFixed(2) + " uur"
      : time.toFixed(0) + " Minuten";
  }

  getQuantiry(article: any): number {
    return this.order.shoppingBag.find(
      (x) => x.articleNumber === article.Nummer
    ).qty;
  }

  open(picker: MatDatepicker<any>) {
    if (!this.isOrderd) {
      picker.open();
    }
  }

  redoOrder() {
    if (this.isOrderd) {
      this.isOrderd = false;
      this.shoppingService.order = this.order;

      this.filterService.brand = this.order.brand;
      this.filterService.type = this.order.car_type;

      this.router.navigate([
        "/",
        "dashboard",
        "place-order",
        "overview",
        "ordered",
        false,
      ]);
    }
  }

  exportOrder() {
    const orderNumbers: string[] = this.order.shoppingBag.map(
      (x) => x.articleNumber
    );
    const data: {
      articleNumber: string;
      Matchcode: string;
      // Omschrijving: string,
      KorteTekst: string;
      Leverancier: string;
      VK1: string;
      Gewicht: number;
      Bestelnummer: string;
      Eenh: string;
      qty: number;
      brand: number;
      type: number;
    }[] = [];

    this.articleService
      .getArticlesFromCsv({
        articleNumbers: orderNumbers,
        companyId: this.userService.getCompany().id,
        newPrice: this.order.car_type.newPrice,
      })
      .subscribe((response) => {
        response.articles.forEach((order) => {
          if (order) {
            data.push({
              articleNumber: order.Nummer,
              Matchcode: order.Matchcode,
              // Omschrijving: order.Omschrijving,
              KorteTekst: order.KorteTekst,
              Leverancier: ".BROVERGELD",
              VK1: order.brutoprijs.toFixed(2),
              Gewicht: order.Gewicht ? order.Gewicht : 0,
              Bestelnummer: this.order.references,
              Eenh: order.Eenheid ? order.Eenheid : "stuk",
              qty: this.order.shoppingBag.find(
                (x) => x.articleNumber === order.Nummer
              ).qty,
              brand: this.order.brand.id,
              type: this.order.car_type.id,
            });
          }
        });

        // setting up headers
        const header = Object.keys(data[0]);
        const csv = data.map((row) =>
          header
            .map((fieldName) =>
              typeof row[fieldName] === "string" &&
                row[fieldName].indexOf(";") > -1
                ? `"${row[fieldName]}"`
                : row[fieldName]
            )
            .join(";")
        );

        csv.unshift(header.join(";"));
        const csvArray = csv.join("\n");
        const blob = new Blob([csvArray], { type: "text/csv" });
        saveAs(
          blob,
          `order-${this.order.references ? this.order.references : this.order.id
          }.csv`
        );
      });
  }

  changeQuantiry(value: string, article: string) {
    const valueAsNumber = parseInt(value, 10);

    if (valueAsNumber > 0) {
      const order: {
        deliverDate: Date;
        shoppingBag: any[];
        references?: string;
        car_type: any;
        brand: any;
        address: string;
        place: string;
        postal_code: string;
      } = this.shoppingService.order;
      order.shoppingBag.find((x) => x.articleNumber === article).qty =
        valueAsNumber;
      this.shoppingService.order = order;
    } else {
      const order: {
        deliverDate: Date;
        shoppingBag: any[];
        references?: string;
        car_type: any;
        brand: any;
        address: string;
        place: string;
        postal_code: string;
      } = this.shoppingService.order;
      order.shoppingBag.find((x) => x.articleNumber === article).qty = 1;
      this.shoppingService.order = order;
    }
  }

  saveOrderder() {
    const dialogRef = this.dialog.open(SaveOrderDialogComponent, {
      width: "400px",
      data: this.order,
    });

    dialogRef.afterClosed().subscribe((x) => {
      if (x) {
        this.notify.success("Offerte opgeslagen");
        this.shoppingService.clearOrder();
        this.filterService.clearBrand();
        this.router.navigate(["/", "dashboard"]);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.isOrderd) {
      this.shoppingService.clearOrder();
      this.filterService.clearBrand();
    }
  }

  cancelOrder() {
    this.shoppingService.clearOrder();
    this.filterService.clearBrand();
    this.router.navigate(["/", "dashboard"]);
  }


  downloadInvoice(feature: any) {
    this.activated.paramMap.subscribe((params) => {
      this.orderService.getOrder(params.get("id") as any).subscribe((x) => {
        let string = "";
        if (feature.tender) {
          string += `<h1> Gebaseerd op offerte </h1>
                 <h4> Referentie ${feature.tender.reference} </h4> 
                 <h4> Uniek referentienummer offerte ${feature.tender.id} </h4>
                 <hr>`;
        }
        const html = htmlToPdfmake(
          `<h1>Bestelbevestiging</h1>
        <hr>
        <hr>
        <h4> Referentie: ${feature.references} </h4>
        <hr>` + string
        );
        const html2 = "Link naar order";
        const docDefinition = {
          content: [
            html,
            {
              table: {
                headerRows: 1,
                widths: ["*", "auto"],
                body: [
                  [
                    { text: "Artikelnummer", bold: true },
                    { text: "Aantal", bold: true },
                  ],
                  [
                    x["data"].items.map((x) => x.article),
                    x["data"].items.map((x) => x.qty),
                  ],
                ],
              },
            },
            html2,
            {
              qr: `https://shop.brover.nl/dashboard/order-history/${params.get(
                "id"
              )}`,
              fit: "100",
            },
          ],
        };
        const pdfDocGenerator = pdfMake.createPdf(docDefinition).open();
      });
    });

    // order: {
    //   id?: number;
    //   deliverDate: Date,
    //   shoppingBag: any[],
    //   references?: string,
    //   car_type: any,
    //   brand: any,
    //   address: string,
    //   place: string,
    //   postal_code: string,
    //   tender?: any,
    // };
  }

  getImageDataURL(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      }
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }


  downloadTender(feature: any) {
    console.log(this.userService.user);
    this.userService.getMe(true, false, true).subscribe(meRes =>
      this.activated.queryParamMap.subscribe((params) => {
        this.tenderService
          .getTender(params.get("tenderId") as any)
          .subscribe((cart) => {
            this.userService.user.subscribe((userInfo) => {
              // tslint:disable-next-line: max-line-length
              this.articleService
                .getArticlesFromCsv({
                  articleNumbers: cart["data"].items.map((x) => x.articleNumber),
                  companyId: userInfo.companies[0].company.id,
                  newPrice: this.order.car_type.newPrice,
                })
                .subscribe((priceArticle) => {
                  const imageStr = encodeURI(environment.uploads + 'gross_' + meRes['data']['companies'][0]['company']['image']);
                  this.userService.getCompanyInfo().subscribe((companyInfo) => {

                    let ee = [];
                    const test = priceArticle.articles.filter((x) =>
                      cart["data"]["items"].filter((y) => {
                        if (y.articleNumber == x.Nummer) {
                          ee.push({
                            qty: y.qty,
                            articleNumber: y.articleNumber,
                            shortText: x.KorteTekst,
                            price: x.brutoprijs.toFixed(2),
                            montageTijd: x.montageTijd,
                          });
                          return true;
                        }
                      })
                    );
                    const calculateTotal = (items) => {
                      let total = 0;
                      items.forEach(item => {
                        total += item.price * item.qty;
                      });
                      return total;
                    };

                    const totalExclVAT = calculateTotal(ee);
                    const totalInclVAT = totalExclVAT * 1.21;

                    const docDefinition = {
                      content: [
                        {
                          columns: [
                            {
                              image: 'logo',
                              width: 100,
                              margin: [0, 0, 0, 20]
                            },
                            {
                              text: 'Offerte',
                              style: 'header',
                              alignment: 'right',
                              margin: [0, 0, 0, 20],
                              width: '*'
                            },
                          ]
                        },
                        {
                          text: `Referentie: ${cart['data']['reference']} | Datum: ${new Date(cart['data']['created']).toLocaleDateString('NL-nl')}`,
                          style: 'subheader',
                          alignment: 'center',
                          margin: [0, 20, 0, 20]
                        },
                        {
                          table: {
                            headerRows: 1,
                            widths: ["auto", "auto", "auto", "auto", "auto"],
                            body: [
                              [
                                { text: "Artikelnummer", bold: true },
                                { text: "Aantal", bold: true },
                                { text: "Omschrijving", bold: true },
                                { text: "Prijs", bold: true },
                                { text: "Totaal", bold: true },
                              ],
                              ...ee.map(x => [
                                { text: String(x.articleNumber) },
                                { text: String(x.qty) },
                                { text: String(x.shortText) },
                                { text: String(x.price) },
                                { text: String((x.price * x.qty).toFixed(2)) }
                              ]),
                              [
                                { colSpan: 5, text: `Totaal excl. BTW: ${totalExclVAT.toFixed(2)}`, bold: true, border: [false, false, false, false], alignment: 'right' }, {}, {}, {}, {}
                              ],
                              [
                                { colSpan: 5, text: `BTW 21%: ${(totalExclVAT * 0.21).toFixed(2)}`, bold: true, border: [false, false, false, false], alignment: 'right' }, {}, {}, {}, {}
                              ],
                              [
                                { colSpan: 5, text: `Totaal incl. BTW: ${totalInclVAT.toFixed(2)}`, bold: true, border: [false, false, false, false], alignment: 'right' }, {}, {}, {}, {}
                              ]
                            ]
                          },
                          layout: 'lightHorizontalLines'
                        },
                      ],
                      styles: {
                        header: {
                          fontSize: 18,
                          bold: true,
                        },
                        subheader: {
                          fontSize: 14,
                          margin: [0, 10, 0, 5]
                        }
                      },
                      images: {
                        logo: imageStr
                      },
                      footer: function (currentPage, pageCount) {
                        return {
                          columns: [
                            {
                              text: 'Pagina ' + currentPage.toString() + ' van ' + pageCount,
                              alignment: 'center',
                              margin: [0, 0, 20, 0]
                            }
                          ]
                        };
                      }
                    };
                    const pdfDocGenerator = pdfMake
                      .createPdf(docDefinition)
                      .open();
                  });
                });
            });
          });
      }));

  }
}
